import { Component, EventEmitter, Output } from '@angular/core';
import { SvgAreaBaseComponent } from '../svg-area-base/svg-area-base.component';
import { ElementSide } from 'src/app/_core/interfaces/IElementSide';

@Component({
	selector: 'g[app-svg-roof]',
	templateUrl: './svg-roof.component.html',
	styleUrls: ['./svg-roof.component.css']
})
export class SvgRoofComponent extends SvgAreaBaseComponent {
	@Output() openLayoutEvent = new EventEmitter<boolean>(false);
	@Output() mouseOverGlassEvent = new EventEmitter<MouseEvent>(null);
	@Output() mouseOutGlassEvent = new EventEmitter<boolean>(false);

	mouseOverGlass(ptr: MouseEvent) {
		this.mouseOverGlassEvent.emit(ptr);
	}

	mouseOutGlass() {
		this.mouseOutGlassEvent.emit(true);
	}

	getOutflowArrowLine(column: any): { x1: number; y1: number; x2: number; y2: number } {
		const centerX = column.rectOnRoof.x + column.rectOnRoof.w / 2;
		const centerY = column.rectOnRoof.y + column.rectOnRoof.h / 2;
		const radius = this.getOutflowMaxRadius(column);
		const arrowLength = radius * 0.65;
		const arrowHeadSize = 5;

		switch (column.outflow) {
			case ElementSide.Top:
				return { x1: centerX, y1: centerY, x2: centerX, y2: centerY - (arrowLength - arrowHeadSize) };
			case ElementSide.Bottom:
				return { x1: centerX, y1: centerY, x2: centerX, y2: centerY + (arrowLength - arrowHeadSize) };
			case ElementSide.Left:
				return { x1: centerX, y1: centerY, x2: centerX - (arrowLength - arrowHeadSize), y2: centerY };
			case ElementSide.Right:
				return { x1: centerX, y1: centerY, x2: centerX + (arrowLength - arrowHeadSize), y2: centerY };
			default:
				return null;
		}
	}

	getOutflowMaxRadius(column: any): number {
		return (Math.min(column.rectOnRoof.w, column.rectOnRoof.h) / 2) - 1;
	}

	getOutflowArrowHead(column: any): string {
		const centerX = column.rectOnRoof.x + column.rectOnRoof.w / 2;
		const centerY = column.rectOnRoof.y + column.rectOnRoof.h / 2;
		const radius = this.getOutflowMaxRadius(column);
		const arrowLength = radius * 0.75;
		const arrowHeadSize = 2.5;

		switch (column.outflow) {
			case ElementSide.Top: {
				const topY = centerY - arrowLength;
				return `${centerX},${topY} ${centerX - arrowHeadSize},${topY + arrowHeadSize * 1.2} ${centerX + arrowHeadSize},${topY + arrowHeadSize * 1.2}`;
			}
			case ElementSide.Bottom: {
				const bottomY = centerY + arrowLength;
				return `${centerX},${bottomY} ${centerX - arrowHeadSize},${bottomY - arrowHeadSize * 1.2} ${centerX + arrowHeadSize},${bottomY - arrowHeadSize * 1.2}`;
			}
			case ElementSide.Left: {
				const leftX = centerX - arrowLength;
				return `${leftX},${centerY} ${leftX + arrowHeadSize * 1.2},${centerY - arrowHeadSize} ${leftX + arrowHeadSize * 1.2},${centerY + arrowHeadSize}`;
			}
			case ElementSide.Right: {
				const rightX = centerX + arrowLength;
				return `${rightX},${centerY} ${rightX - arrowHeadSize * 1.2},${centerY - arrowHeadSize} ${rightX - arrowHeadSize * 1.2},${centerY + arrowHeadSize}`;
			}
			default:
				return '';
		}
	}

}
